import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS, apiRequest } from '@/lib/api';

export interface Sprint {
  id: number;
  name: string;
  start_date: string | null;
  end_date: string | null;
  total_possible_hours: number;
}

export function useSprints(projectId: number | null) {
  return useQuery({
    queryKey: ['project', projectId, 'sprints'],
    queryFn: async () => {
      if (!projectId) {
        throw new Error('Project ID is required');
      }

      const response = await apiRequest(
        `${API_ENDPOINTS.SPRINTS}?project=${projectId}`
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ 
          detail: 'Failed to fetch sprints' 
        }));
        throw new Error(errorData.detail || 'Failed to fetch sprints');
      }

      const data = await response.json();
      return (data.results || data) as Sprint[];
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}



